import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PageHeader, ScopeNotice, useScopeGuard } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const estadoColor = {
  pendiente: "bg-[#F59E0B] hover:bg-[#F59E0B]", reintento: "bg-[#F59E0B] hover:bg-[#F59E0B]",
  enviado: "bg-[#10B981] hover:bg-[#10B981]", fallido: "bg-[#EF4444] hover:bg-[#EF4444]",
};

export default function Nucleo() {
  const { user, scopeTenant } = useAuth();
  const needsScope = useScopeGuard(user, scopeTenant);
  const [eventos, setEventos] = useState([]);

  const load = useCallback(async () => {
    if (needsScope) return;
    const { data } = await api.get("/nucleo/eventos");
    setEventos(data);
  }, [needsScope]);
  useEffect(() => { load(); }, [load]);

  if (needsScope) return <ScopeNotice />;

  return (
    <div data-testid="nucleo-page">
      <PageHeader overline="Integración" title="Cola de Eventos · Núcleo Agentik" />
      <Card className="p-4 border-[#E2E8F0] mb-4 text-sm text-[#0E2A47]/70">
        Los eventos se encolan y se envían al webhook de Núcleo (worker cada 10 min, máx. 5 reintentos).
        Si <span className="font-mono">NUCLEO_WEBHOOK_URL</span> está vacía, permanecen pendientes.
      </Card>
      <Card className="border-[#E2E8F0] overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-[#F7F8FA]">
            <TableHead>Tipo</TableHead><TableHead>Estado</TableHead><TableHead>Intentos</TableHead>
            <TableHead>Creado</TableHead><TableHead>Último error</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {eventos.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-[#0E2A47]/50 py-8">Sin eventos.</TableCell></TableRow>}
            {eventos.map((e) => (
              <TableRow key={e.id} data-testid={`evento-row-${e.id}`} className="hover:bg-[#F7F8FA]">
                <TableCell className="font-mono text-xs text-[#0E2A47]">{e.tipo}</TableCell>
                <TableCell><Badge className={estadoColor[e.estado] || "bg-slate-400"}>{e.estado}</Badge></TableCell>
                <TableCell>{e.intentos}/5</TableCell>
                <TableCell className="text-[#0E2A47]/60 text-sm">{new Date(e.creado_en).toLocaleString("es-ES")}</TableCell>
                <TableCell className="text-xs text-[#EF4444] max-w-xs truncate">{e.ultimo_error || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
